import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({
    name: 'safehtml',
    standalone: false
})
export class SafehtmlPipe implements PipeTransform {
  constructor(private sanitized: DomSanitizer) {}
  transform(value: any,editInduction?: boolean) {
    if(editInduction){
    return this.sanitized.sanitize(SecurityContext.HTML, this.sanitized.bypassSecurityTrustHtml(value)) 
    }else{
    return this.sanitized.bypassSecurityTrustHtml(value);
    }
  }


}
